import { del, get, post, put } from '../utils/httpInterceptor';
import { getCompanyId } from '../utils/companyHelper';
import { buildCrudQueryParams } from './filterQueryBuilder';

class BpmModelerService {
  static async getAll(page, size, filters = {}, sortConfig = {}) {
    const companyId = getCompanyId();
    const queryParams = buildCrudQueryParams({
      page,
      size,
      filters,
      sortConfig,
      companyId,
      sortMode: 'split',
    });

    return get(`/bpm-modeler?${queryParams.toString()}`);
  }

  static async getById(id) {
    return get(`/bpm-modeler/${id}`);
  }

  static async getVersionById(versionId) {
    return get(`/bpm-modeler/version/${versionId}`);
  }

  static async getByKey(modelerKey) {
    return get(`/bpm-modeler/modeler-key/${encodeURIComponent(modelerKey)}`);
  }

  static async getAllByKey(modelerKey) {
    return get(`/bpm-modeler/all-modelers-by-modelekey/${encodeURIComponent(modelerKey)}`);
  }

  static async create(payload) {
    const companyId = getCompanyId();
    return post('/bpm-modeler', { ...payload, companyId });
  }

  static async update(id, payload) {
    const companyId = getCompanyId();
    return put(`/bpm-modeler/${id}`, { ...payload, companyId });
  }

  static async updateEnabled(id, payload) {
    const companyId = getCompanyId();
    return put(`/bpm-modeler/${id}`, { ...payload, companyId });
  }

  static async delete(id) {
    return del(`/bpm-modeler/${id}`);
  }
}

export default BpmModelerService;
